// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/event_timeline.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventPlanInputChange, EventTimelineBlock, TimelineBlockKindEnum } from "./event_plan_pb";
import { file_cortado_v1_event_plan } from "./event_plan_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/event_timeline.proto.
 */
export const file_cortado_v1_event_timeline: GenFile = /*@__PURE__*/
  fileDesc("Ch9jb3J0YWRvL3YxL2V2ZW50X3RpbWVsaW5lLnByb3RvEgpjb3J0YWRvLnYxIoADCg1FdmVudFRpbWVsaW5lEhAKCGV2ZW50X2lkGAEgASgJEi4KBmJsb2NrcxgCIAMoCzIeLmNvcnRhZG8udjEuRXZlbnRUaW1lbGluZUJsb2NrEhUKDWlzX2N1c3RvbWl6ZWQYAyABKAgSMAoMZ2VuZXJhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIaChJpbnB1dHNfZmluZ2VycHJpbnQYBiABKAkSIgoaY3VycmVudF9pbnB1dHNfZmluZ2VycHJpbnQYByABKAkSMQoHY2hhbmdlcxgIIAMoCzIgLmNvcnRhZG8udjEuRXZlbnRQbGFuSW5wdXRDaGFuZ2USGAoQZHJpdmVfdGltZV9rbm93bhgJIAEoCBIVCg1kcml2ZV9taW51dGVzGAogASgFEhAKCHRpbWV6b25lGAsgASgJIisKF0dldEV2ZW50VGltZWxpbmVSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJIkcKGEdldEV2ZW50VGltZWxpbmVSZXNwb25zZRIrCgh0aW1lbGluZRgBIAEoCzIZLmNvcnRhZG8udjEuRXZlbnRUaW1lbGluZSK7AQoXRXZlbnRUaW1lbGluZUJsb2NrSW5wdXQSDwoCaWQYASABKAlIAIgBARIvCgRraW5kGAIgASgOMiEuY29ydGFkby52MS5UaW1lbGluZUJsb2NrS2luZEVudW0SDQoFbGFiZWwYAyABKAkSKQoFc3RhcnQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB21pbnV0ZXMYBSABKAUSDAoEbm90ZRgGIAEoCUIFCgNfaWQiaQogVXBkYXRlRXZlbnRUaW1lbGluZUJsb2Nrc1JlcXVlc3QSEAoIZXZlbnRfaWQYASABKAkSMwoGYmxvY2tzGAIgAygLMiMuY29ydGFkby52MS5FdmVudFRpbWVsaW5lQmxvY2tJbnB1dCJQCiFVcGRhdGVFdmVudFRpbWVsaW5lQmxvY2tzUmVzcG9uc2USKwoIdGltZWxpbmUYASABKAsyGS5jb3J0YWRvLnYxLkV2ZW50VGltZWxpbmUiMgoeUmVnZW5lcmF0ZUV2ZW50VGltZWxpbmVSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJIk4KH1JlZ2VuZXJhdGVFdmVudFRpbWVsaW5lUmVzcG9uc2USKwoIdGltZWxpbmUYASABKAsyGS5jb3J0YWRvLnYxLkV2ZW50VGltZWxpbmVCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_cortado_v1_event_plan, file_google_protobuf_timestamp]);

/**
 * @generated from message cortado.v1.EventTimeline
 */
export type EventTimeline = Message<"cortado.v1.EventTimeline"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * In display order. `id` is set on every block; `note` explains a
   * generated adjustment or holds what someone typed.
   *
   * @generated from field: repeated cortado.v1.EventTimelineBlock blocks = 2;
   */
  blocks: EventTimelineBlock[];

  /**
   * Someone edited the blocks since they were generated.
   *
   * @generated from field: bool is_customized = 3;
   */
  isCustomized: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 4;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * Fingerprint of the inputs the blocks were generated from.
   *
   * @generated from field: string inputs_fingerprint = 6;
   */
  inputsFingerprint: string;

  /**
   * Fingerprint of the event's inputs now; differs from inputs_fingerprint
   * when the timeline is stale.
   *
   * @generated from field: string current_inputs_fingerprint = 7;
   */
  currentInputsFingerprint: string;

  /**
   * What changed since the blocks were generated, for the stale notice.
   * Empty when the timeline is current.
   *
   * @generated from field: repeated cortado.v1.EventPlanInputChange changes = 8;
   */
  changes: EventPlanInputChange[];

  /**
   * The drive time a regenerate would use now.
   *
   * @generated from field: bool drive_time_known = 9;
   */
  driveTimeKnown: boolean;

  /**
   * @generated from field: int32 drive_minutes = 10;
   */
  driveMinutes: number;

  /**
   * IANA zone the day offsets are computed in: the event's, else the org's,
   * else UTC.
   *
   * @generated from field: string timezone = 11;
   */
  timezone: string;
};

/**
 * Describes the message cortado.v1.EventTimeline.
 * Use `create(EventTimelineSchema)` to create a new message.
 */
export const EventTimelineSchema: GenMessage<EventTimeline> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 0);

/**
 * @generated from message cortado.v1.GetEventTimelineRequest
 */
export type GetEventTimelineRequest = Message<"cortado.v1.GetEventTimelineRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.GetEventTimelineRequest.
 * Use `create(GetEventTimelineRequestSchema)` to create a new message.
 */
export const GetEventTimelineRequestSchema: GenMessage<GetEventTimelineRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 1);

/**
 * GetEventTimelineResponse returns the saved timeline, generating it first
 * when the event has none. Requires an event date (FailedPrecondition
 * otherwise).
 *
 * @generated from message cortado.v1.GetEventTimelineResponse
 */
export type GetEventTimelineResponse = Message<"cortado.v1.GetEventTimelineResponse"> & {
  /**
   * @generated from field: cortado.v1.EventTimeline timeline = 1;
   */
  timeline?: EventTimeline;
};

/**
 * Describes the message cortado.v1.GetEventTimelineResponse.
 * Use `create(GetEventTimelineResponseSchema)` to create a new message.
 */
export const GetEventTimelineResponseSchema: GenMessage<GetEventTimelineResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 2);

/**
 * EventTimelineBlockInput is one block of an edited timeline.
 *
 * @generated from message cortado.v1.EventTimelineBlockInput
 */
export type EventTimelineBlockInput = Message<"cortado.v1.EventTimelineBlockInput"> & {
  /**
   * A current block's ID keeps its identity; omit for a new block.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Generated kinds keep theirs; added blocks use CUSTOM.
   *
   * @generated from field: cortado.v1.TimelineBlockKindEnum kind = 2;
   */
  kind: TimelineBlockKindEnum;

  /**
   * 1-80 characters after trimming.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Within 72 hours of the event start.
   *
   * @generated from field: google.protobuf.Timestamp start = 4;
   */
  start?: Timestamp;

  /**
   * 0-1440.
   *
   * @generated from field: int32 minutes = 5;
   */
  minutes: number;

  /**
   * Up to 200 characters.
   *
   * @generated from field: string note = 6;
   */
  note: string;
};

/**
 * Describes the message cortado.v1.EventTimelineBlockInput.
 * Use `create(EventTimelineBlockInputSchema)` to create a new message.
 */
export const EventTimelineBlockInputSchema: GenMessage<EventTimelineBlockInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 3);

/**
 * UpdateEventTimelineBlocksRequest replaces every block with `blocks`, in
 * order: label, start and duration edits, added and removed blocks, and
 * reordering all go through it. The timeline is marked customized. 1-24
 * blocks.
 *
 * @generated from message cortado.v1.UpdateEventTimelineBlocksRequest
 */
export type UpdateEventTimelineBlocksRequest = Message<"cortado.v1.UpdateEventTimelineBlocksRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: repeated cortado.v1.EventTimelineBlockInput blocks = 2;
   */
  blocks: EventTimelineBlockInput[];
};

/**
 * Describes the message cortado.v1.UpdateEventTimelineBlocksRequest.
 * Use `create(UpdateEventTimelineBlocksRequestSchema)` to create a new message.
 */
export const UpdateEventTimelineBlocksRequestSchema: GenMessage<UpdateEventTimelineBlocksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 4);

/**
 * @generated from message cortado.v1.UpdateEventTimelineBlocksResponse
 */
export type UpdateEventTimelineBlocksResponse = Message<"cortado.v1.UpdateEventTimelineBlocksResponse"> & {
  /**
   * @generated from field: cortado.v1.EventTimeline timeline = 1;
   */
  timeline?: EventTimeline;
};

/**
 * Describes the message cortado.v1.UpdateEventTimelineBlocksResponse.
 * Use `create(UpdateEventTimelineBlocksResponseSchema)` to create a new message.
 */
export const UpdateEventTimelineBlocksResponseSchema: GenMessage<UpdateEventTimelineBlocksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 5);

/**
 * @generated from message cortado.v1.RegenerateEventTimelineRequest
 */
export type RegenerateEventTimelineRequest = Message<"cortado.v1.RegenerateEventTimelineRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.RegenerateEventTimelineRequest.
 * Use `create(RegenerateEventTimelineRequestSchema)` to create a new message.
 */
export const RegenerateEventTimelineRequestSchema: GenMessage<RegenerateEventTimelineRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 6);

/**
 * RegenerateEventTimelineResponse is the timeline recalculated from the
 * event's current inputs. Edits are discarded.
 *
 * @generated from message cortado.v1.RegenerateEventTimelineResponse
 */
export type RegenerateEventTimelineResponse = Message<"cortado.v1.RegenerateEventTimelineResponse"> & {
  /**
   * @generated from field: cortado.v1.EventTimeline timeline = 1;
   */
  timeline?: EventTimeline;
};

/**
 * Describes the message cortado.v1.RegenerateEventTimelineResponse.
 * Use `create(RegenerateEventTimelineResponseSchema)` to create a new message.
 */
export const RegenerateEventTimelineResponseSchema: GenMessage<RegenerateEventTimelineResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_timeline, 7);

